// import React, { useState, useRef, useEffect } from "react";
// import DropDownIcon from "../../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";
// import "./multiselectedsearch.css";

// export default function MultiSelectSearchDropdown({
//   width,
//   label,
//   selected,
//   setSelected,
//   options,
//   customWidth,
//   customTop,
//   isRequired,
//   Height,
//   OverFlow,
//   minheight,
//   placeholder = "",
//   marginLeft,
//   marginTop,
//   showSelectAll,
//   disabled,
//   singleSelect = false,
//   onSearchInputChange,
// }) {
//   const [isActive, setIsActive] = useState(false);
//   const [searchKey, setSearchKey] = useState("");
//   const [filteredOptions, setFilteredOptions] = useState(options);
//   const dropdownRef = useRef(null);

//   // Normalize selected so that in multi-select mode it's always an array.
//   // For singleSelect we wrap the value in an array if not null.
//   const normalizedSelected = singleSelect
//     ? selected != null
//       ? [selected]
//       : []
//     : selected || [];

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsActive(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   useEffect(() => {
//     if (searchKey === "") {
//       setFilteredOptions(options);
//     } else {
//       setFilteredOptions(
//         options.filter((option) =>
//           option.label.toLowerCase().includes(searchKey.toLowerCase())
//         )
//       );
//     }
//   }, [searchKey, options]);

//   // Clear searchKey when auto-selection happens
//   useEffect(() => {
//     if (normalizedSelected.length > 0) {
//       setSearchKey("");
//     }
//   }, [normalizedSelected]);

//   const handleSelect = (option) => {
//     if (singleSelect) {
//       setSelected(option.id);
//       setSearchKey("");
//       setIsActive(false);
//     } else {
//       const isOptionSelected = normalizedSelected.includes(option.id);
//       if (isOptionSelected) {
//         setSelected(normalizedSelected.filter((id) => id !== option.id));
//       } else {
//         setSelected([...normalizedSelected, option.id]);
//       }
//     }
//   };

//   const handleSelectAll = () => {
//     if (singleSelect) return;
//     if (normalizedSelected.length === options.length) {
//       setSelected([]);
//     } else {
//       setSelected(options.map((option) => option.id));
//     }
//   };

//   const clearValue = () => {
//     if (singleSelect) {
//       setSelected("");
//     } else {
//       setSelected([]);
//     }
//     setSearchKey("");
//   };

//   // console.log("Dropdown debug:", {
//   //   selected,
//   //   label: options.find((opt) => opt.id === selected)?.label,
//   //   options,
//   //   matched: options.find((opt) => opt.id === selected),
//   // });

//   const displayValue = singleSelect
//     ? options.find((opt) => opt.id === selected)?.label || searchKey
//     : normalizedSelected.length > 0
//     ? options
//         .filter((opt) => normalizedSelected.includes(opt.id))
//         .map((opt) => opt.label)
//         .join(", ")
//     : searchKey;

//   const handleChange = (e) => {
//     const newKey = e.target.value;
//     setSearchKey(newKey);
//     if (onSearchInputChange) {
//       onSearchInputChange(newKey);
//     }
//   };

//   return (
//     <div
//       className="dropdown"
//       style={{
//         width,
//         marginLeft,
//         marginTop,
//         opacity: disabled ? 0.5 : 1,
//         pointerEvents: disabled ? "none" : "auto",
//       }}
//       ref={dropdownRef}
//     >
//       <label>
//         {label}
//         {isRequired && <span>*</span>}
//       </label>
//       <div className="dropdown-btn" onClick={() => setIsActive(true)}>
//         <input
//           type="text"
//           className="dropdown-input"
//           style={{ color: "#6A6A6A" }}
//           placeholder={placeholder}
//           value={displayValue}
//           onChange={handleChange}
//           onFocus={() => setIsActive(true)}
//         />
//         {displayValue && (
//           <span
//             style={{
//               cursor: "pointer",
//               color: "#aaa",
//               marginRight: "30px",
//               fontSize: "16px",
//               userSelect: "none",
//             }}
//             onClick={(e) => {
//               e.stopPropagation();
//               clearValue();
//             }}
//           >
//             ×
//           </span>
//         )}
//         <img src={DropDownIcon} alt="dropdown-icon" />
//       </div>
//       {isActive && (
//         <div
//           className="dropdown-content"
//           style={{
//             width: customWidth,
//             top: customTop,
//             maxHeight: "200px", // vertical scrollbar if content exceeds 200px
//             overflowY: "auto",
//             overflowX: "hidden",
//           }}
//         >
//           {showSelectAll && !singleSelect && options.length > 0 && (
//             <div
//               className="dropdown-item"
//               style={{ display: "flex", alignItems: "center", gap: "10px" }}
//             >
//               <input
//                 type="checkbox"
//                 className="delete-question-checkbox-dqc"
//                 checked={
//                   normalizedSelected.length > 0 &&
//                   normalizedSelected.length === options.length
//                 }
//                 onChange={handleSelectAll}
//               />
//               <label onClick={handleSelectAll}>Select All</label>
//             </div>
//           )}
//           {filteredOptions.length > 0 ? (
//             filteredOptions.map((option) => (
//               <div
//                 key={option.id}
//                 className="dropdown-item"
//                 style={{ display: "flex", alignItems: "center", gap: "10px" }}
//               >
//                 <input
//                   type="checkbox"
//                   className="delete-question-checkbox-dqc"
//                   checked={
//                     singleSelect
//                       ? selected === option.id
//                       : normalizedSelected.includes(option.id)
//                   }
//                   onChange={() => handleSelect(option)}
//                 />
//                 <label onClick={() => handleSelect(option)}>
//                   {option.label}
//                 </label>
//               </div>
//             ))
//           ) : (
//             <div className="dropdown-no-results">No results found</div>
//           )}
//         </div>
//       )}
//     </div>
//   );
// }
















import React, { useState, useRef, useEffect } from "react";
import DropDownIcon from "../../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";
import "./multiselectedsearch.css";

export default function MultiSelectSearchDropdown({
  width,
  label,
  selected,
  setSelected,
  options,
  customWidth,
  customTop,
  isRequired,
  Height,
  OverFlow,
  minheight,
  placeholder = "",
  marginLeft,
  marginTop,
  showSelectAll,
  disabled,
  singleSelect = false,
  onSearchInputChange,
}) {
  const [isActive, setIsActive] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const dropdownRef = useRef(null);

  // Normalize selected so that in multi-select mode it's always an array.
  // For singleSelect we wrap the value in an array if not null.
  const normalizedSelected = singleSelect
    ? selected != null
      ? [selected]
      : []
    : selected || [];

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (searchKey === "") {
      setFilteredOptions(options);
    } else {
      setFilteredOptions(
        options.filter((option) =>
          option.label.toLowerCase().includes(searchKey.toLowerCase())
        )
      );
    }
  }, [searchKey, options]);

  // Clear searchKey when auto-selection happens
  useEffect(() => {
    if (normalizedSelected.length > 0) {
      setSearchKey("");
    }
  }, [normalizedSelected]);

  const handleSelect = (option) => {
    if (singleSelect) {
      setSelected(option.id);
      setSearchKey("");
      setIsActive(false);
    } else {
      const isOptionSelected = normalizedSelected.includes(option.id);
      if (isOptionSelected) {
        setSelected(normalizedSelected.filter((id) => id !== option.id));
      } else {
        setSelected([...normalizedSelected, option.id]);
      }
    }
  };

  const handleSelectAll = () => {
    if (singleSelect) return;
    if (normalizedSelected.length === options.length) {
      setSelected([]);
    } else {
      setSelected(options.map((option) => option.id));
    }
  };

  const clearValue = () => {
    if (singleSelect) {
      setSelected("");
    } else {
      // Re-select all options (clearing back to the "All" default state)
      setSelected(options.map((o) => o.id));
    }
    setSearchKey("");
  };

  // console.log("Dropdown debug:", {
  //   selected,
  //   label: options.find((opt) => opt.id === selected)?.label,
  //   options,
  //   matched: options.find((opt) => opt.id === selected),
  // });

  const displayValue = singleSelect
    ? options.find((opt) => opt.id === selected)?.label || searchKey
    : normalizedSelected.length > 0 && normalizedSelected.length === options.length
    ? "All"
    : normalizedSelected.length > 0
    ? options
        .filter((opt) => normalizedSelected.includes(opt.id))
        .map((opt) => opt.label)
        .join(", ")
    : searchKey;

  const handleChange = (e) => {
    const newKey = e.target.value;
    setSearchKey(newKey);
    if (onSearchInputChange) {
      onSearchInputChange(newKey);
    }
  };

  return (
    <div
      className="dropdown"
      style={{
        width,
        marginLeft,
        marginTop,
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? "none" : "auto",
      }}
      ref={dropdownRef}
    >
      <label>
        {label}
        {isRequired && <span>*</span>}
      </label>
      <div className="dropdown-btn" onClick={() => setIsActive(true)}>
        <input
          type="text"
          className="dropdown-input"
          style={{ color: "#6A6A6A" }}
          placeholder={placeholder}
          value={displayValue}
          onChange={handleChange}
          onFocus={() => setIsActive(true)}
        />
        {displayValue && displayValue !== "All" && (
          <span
            style={{
              cursor: "pointer",
              color: "#aaa",
              marginRight: "30px",
              fontSize: "16px",
              userSelect: "none",
            }}
            onClick={(e) => {
              e.stopPropagation();
              clearValue();
            }}
          >
            ×
          </span>
        )}
        <img src={DropDownIcon} alt="dropdown-icon" />
      </div>
      {isActive && (
        <div
          className="dropdown-content"
          style={{
            width: customWidth,
            top: customTop,
            maxHeight: "200px", // vertical scrollbar if content exceeds 200px
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          {showSelectAll && !singleSelect && options.length > 0 && (
            <div
              className="dropdown-item"
              style={{ display: "flex", alignItems: "center", gap: "10px" }}
            >
              <input
                type="checkbox"
                className="delete-question-checkbox-dqc"
                checked={
                  normalizedSelected.length > 0 &&
                  normalizedSelected.length === options.length
                }
                onChange={handleSelectAll}
              />
              <label onClick={handleSelectAll}>Select All</label>
            </div>
          )}
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option) => (
              <div
                key={option.id}
                className="dropdown-item"
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <input
                  type="checkbox"
                  className="delete-question-checkbox-dqc"
                  checked={
                    singleSelect
                      ? selected === option.id
                      : normalizedSelected.includes(option.id)
                  }
                  onChange={() => handleSelect(option)}
                />
                <label onClick={() => handleSelect(option)}>
                  {option.label}
                </label>
              </div>
            ))
          ) : (
            <div className="dropdown-no-results">No results found</div>
          )}
        </div>
      )}
    </div>
  );
}